import {buildTheme} from './core/mui-theme';

export const theme = buildTheme();
export { breakpoints, media } from './core/breakpoints';
export { tokens } from './tokens/tokens';